import { formatNumberWithMaxTwoDigitsAfterSeparator, formatNumberWithCommasInteger } from '@shared/utils/numberFormat';

export function formatMinMaxRange(minValue: number, maxValue: number, isRounded?: boolean) {
  if (isRounded) {
    return `${formatNumberWithCommasInteger(minValue)} - ${formatNumberWithCommasInteger(maxValue)}`;
  } else {
    return `${formatNumberWithMaxTwoDigitsAfterSeparator(minValue)} - ${formatNumberWithMaxTwoDigitsAfterSeparator(maxValue)}`;
  }
}
